import React, { useState, useEffect } from 'react'
import { uploadOrderFile, getMarketplace_AllowCreateOrder, getUserMarketplace } from 'services/dataservice';
import { Form, FormGroup, Label, Input, Card, CardHeader, CardBody, CardFooter, Button, CardTitle, List, Table } from 'reactstrap';
import { Link } from "react-router-dom"

import ReactBSAlert from 'react-bootstrap-sweetalert';
import { uploadB2BCommerce } from 'services/dataservice';

export default function B2BCommerce(props) {
   const [alert, setAlert] = useState(null);
   const [selectedFile, setFile] = useState([]);
   const [retailer, setRetailer] = useState("WATSONS");
   

   const [isUpload, setIsUpload] = useState(false)
   const [errData,setErrData] = useState(null)


   const showSuccess = (msg, callBack = null) => {
      setAlert(
         <ReactBSAlert
            success
            style={{ display: "block" }}
            title={msg}
            onConfirm={() => callBack == null ? setAlert(null) : callBack()}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="info">
         </ReactBSAlert>
      )
   };


   const showFail = (msg) => {
      setAlert(
         <ReactBSAlert
            danger
            style={{ display: "block", marginTop: "-100px" }}
            title={msg}
            onConfirm={() => setAlert(null)}
            onCancel={() => setAlert(null)}
            confirmBtnBsStyle="info"
            btnSize=""
         >
         </ReactBSAlert>
      )
   }


   const fileUpload = async () => {
      setIsUpload(true)
      let formData = new FormData();
      console.log(retailer)
      formData.append("retailer", retailer);

      for (var file of selectedFile) {
         formData.append(
            "files",
            file,
            file.name
         );

      }
      console.log(formData);

      if (!Boolean(retailer) || selectedFile.length == 0) {
         showFail("Order Failed To Upload");
         setIsUpload(false)
         return;
      }
      setErrData(null)
      try {
         const resp = await uploadB2BCommerce(formData);
         let status = resp.data.code;
         if (status === 200) {
            document.getElementById("fileSelector").value = "";
            setFile([])
            showSuccess("Order Uploaded");
            setIsUpload(false)
         }
         else if (status === 500) {
            showFail(resp.data.description);
            setIsUpload(false)
            if(resp.data.error==="order_fail"){
               setErrData(resp.data.data)
            }
         }
      }
      catch {
         showFail("Order Failed To Upload");
         setIsUpload(false)
      }
   }

   const onFileChange = event => {
      let array = [];
      for (var file of event.target.files) {
         array.push(file);
      }
      console.log(array);
      setFile(array);
   }

   return (
      <div className="content">
         {alert}
         <Card>
            <CardHeader>
               <CardTitle tag="h4">
                  B2B Commerce
               </CardTitle>
            </CardHeader>
            <CardBody>
               <Form>
                  <FormGroup>
                     <Label for="platform">Retailer</Label>
                     <Input type="select" value={retailer} id="platform" onChange={e => setRetailer(e.target.value)}>
                        <option key="WATSONS" value="WATSONS">WATSONS</option>
                        <option key="AEON" value="AEON">AEON</option>
                        <option key="GUARDIAN" value="GUARDIAN">GUARDIAN</option>
                     </Input>
                  </FormGroup>
                  <FormGroup>
                     <Label for="fileSelector">Order File</Label>
                     <Input type="file" name="file" onChange={onFileChange} id="fileSelector"></Input>
                  </FormGroup>
               </Form>
            </CardBody>
            <CardFooter>
               <Button onClick={fileUpload} disabled={isUpload}>{isUpload?"Uploading":"Upload"}</Button>
            </CardFooter>
         </Card>

         {errData &&
            <Card>
               <CardHeader>
                  <CardTitle tag="h4">Upload Response</CardTitle>
               </CardHeader>
               <CardBody>
                  {/* <div>{errData}</div> */}
                  <ErrorListView errData={errData}/>
               </CardBody>
            </Card>
         }

      </div>
   )
}

const ErrorListView = ({errData}) => {
   let errors = JSON.parse(errData);
   return (
     <Table>
       <thead className="text-primary">
         <th className="='text-center">#</th>
         <th>Order Number</th>
         <th>Error</th>
       </thead>
       <tbody>
         {Object.entries(errors).map(([key, values], index) => {
           return (
             <tr key={key}>
               <td className="text-center">{index + 1}</td>
               <td>{key}</td>
               <td>
                 <ul>
                   {values.map((_error) => {
                     return <li>{_error}</li>;
                   })}
                 </ul>
               </td>
             </tr>
           );
         })}
       </tbody>
     </Table>
   );
 }